import React, { createContext } from "react";

/**
 * @typedef {Object} Subscription The subscription object
 * @property {string} id - The unique subscription ID
 */

/**
 * @typedef {Object} StripeContextValue
 * @property {Subscription | undefined} subscription - The active or trialing subscription
 * @property {Object} products - All products and subscriptions from our main Stripe
 * @property {boolean} isLoading - Whether the subscription data is currently loading
 * @property {Error | null} error - Any error that occurred during loading
 * @property {(props: {checkConnectAccountStatus: boolean}) => React.JSX.Element} LockedFeature
 * @property {() => {}} togglePriceModal
 * @property {() => {}} toggleAccountMgmtModal
 * @property {Object} accountUrl - The account URL object with type and url
 * @property {() => Promise<any>} checkConnectAccountStatus - Object containing Stripe Connect functionality
 * @property {{complete: boolean}} connectAccountStatus - Provides information on the Stripe Connect account
 * @property {React.JSX.Element} ConnectAccountStatus - The component that allows managing the connected account
 * @property {{complete: boolean}} customerIsPRO - Provides information if the user has the pro subscription
 */

/**
 * StripeContext provides real-time subscription data from Firestore for the current user.
 * It must be used within a <StripeWrapper>.
 * @type {React.Context<StripeContextValue | null>}
 */
export const StripeContext = createContext(null);
